// import React, { useState, useEffect, useRef } from "react";
// import axiosInstance from "../utils/axiosInstance";

// const LetterList = () => {
//   const [letters, setLetters] = useState([]);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [templateOptions, setTemplateOptions] = useState([]);
//   const [selectedFormat, setSelectedFormat] = useState("pdf");
//   const [selectedTemplate, setSelectedTemplate] = useState("1");
//   const observer = useRef();
//   const lastLetterElementRef = useRef();

//   // Fetch template options on component mount
//   useEffect(() => {
//     const fetchTemplates = async () => {
//       try {
//         const response = await axiosInstance.get(
//           "/documents/letter-templates/options/"
//         );
//         setTemplateOptions(response.data.templates || []);
//       } catch (err) {
//         setError("خطا در بارگذاری قالب‌ها");
//         console.error("Template fetch error:", err);
//       }
//     };
//     fetchTemplates();
//   }, []);

//   // Fetch letters with pagination
//   useEffect(() => {
//     const fetchLetters = async () => {
//       setLoading(true);
//       try {
//         const response = await axiosInstance.get(
//           `/documents/letters/?page=${page}`
//         );
//         const newLetters = response.data.results || [];
//         setLetters((prev) => [...prev, ...newLetters]);
//         setHasMore(response.data.next !== null);
//       } catch (err) {
//         setError("خطا در بارگذاری نامه‌ها");
//         console.error("Letters fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchLetters();
//   }, [page]);

//   // Implement lazy loading with IntersectionObserver
//   useEffect(() => {
//     if (!hasMore || loading) return;

//     const currentObserver = observer.current;
//     if (lastLetterElementRef.current) {
//       currentObserver?.disconnect();
//     }

//     observer.current = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting && hasMore) {
//           setPage((prev) => prev + 1);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (lastLetterElementRef.current) {
//       observer.current.observe(lastLetterElementRef.current);
//     }

//     return () => {
//       if (currentObserver) currentObserver.disconnect();
//     };
//   }, [hasMore, loading]);

//   const handleDownload = async (letterId, title) => {
//     try {
//       const format = selectedFormat || "pdf";
//       const templateId = selectedTemplate || "1";
//       const endpoint =
//         format === "pdf"
//           ? "/documents/letter/render-pdf/"
//           : "/documents/letter/render-docx/";

//       const response = await axiosInstance.post(
//         endpoint,
//         {
//           letter_id: letterId,
//           template_id: templateId,
//         },
//         {
//           responseType: "blob",
//         }
//       );

//       const url = URL.createObjectURL(response.data);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${title}.${format}`;
//       link.click();
//       URL.revokeObjectURL(url);
//     } catch (err) {
//       setError("خطا در دانلود نامه");
//       console.error("Download error:", err);
//     }
//   };

//   return (
//     <div
//       dir="rtl"
//       className="text-right p-6 max-w-2xl mx-auto bg-white shadow-lg rounded-lg mt-24"
//     >
//       <h2 className="text-2xl font-semibold mb-6 text-gray-800">
//         لیست نامه‌های ایجاد شده
//       </h2>

//       <div className="mb-5">
//         <label
//           htmlFor="format"
//           className="block mb-2 text-sm font-medium text-gray-700"
//         >
//           فرمت فایل:
//         </label>
//         <select
//           id="format"
//           value={selectedFormat}
//           onChange={(e) => setSelectedFormat(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="pdf">PDF</option>
//           <option value="docx">DOCX</option>
//         </select>
//       </div>

//       <div className="mb-5">
//         <label
//           htmlFor="template"
//           className="block mb-2 text-sm font-medium text-gray-700"
//         >
//           قالب نامه:
//         </label>
//         <select
//           id="template"
//           value={selectedTemplate}
//           onChange={(e) => setSelectedTemplate(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="1">قالب پیش‌فرض</option>
//           {templateOptions.map((option) => (
//             <option key={option.id} value={option.id}>
//               {option.name}
//             </option>
//           ))}
//         </select>
//       </div>

//       {letters.length === 0 && !loading && (
//         <p className="text-gray-500">هیچ نامه‌ای یافت نشد.</p>
//       )}
//       <ul className="space-y-4">
//         {letters.map((letter, index) => {
//           const isLastElement = letters.length === index + 1;
//           return (
//             <li
//               key={letter.id}
//               ref={isLastElement ? lastLetterElementRef : null}
//               className="p-4 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
//             >
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="font-medium text-gray-800">{letter.title}</p>
//                   <p className="text-sm text-gray-500">تاریخ: {letter.date}</p>
//                 </div>
//                 <button
//                   onClick={() => handleDownload(letter.id, letter.title)}
//                   className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors"
//                 >
//                   دانلود
//                 </button>
//               </div>
//             </li>
//           );
//         })}
//       </ul>
//       {loading && <p className="text-gray-500 mt-4">در حال بارگذاری...</p>}
//       {error && <p className="text-red-500 text-sm mt-4">{error}</p>}
//     </div>
//   );
// };

// export default LetterList;

import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
import { Trash2, Edit } from "lucide-react";
import { Link } from "react-router-dom";
import PaginationControls from "../components/PaginationControls";
import HotToastMessage from "../components/ui/HotToastMessage";

const LetterList = () => {
  const [letters, setLetters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [, setCount] = useState(0);
  const [next, setNext] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState("pdf");
  const [selectedTemplate, setSelectedTemplate] = useState("1");
  const [toast, setToast] = useState({ message: "", type: "info" });

  const hasNext = !!next;
  const hasPrevious = !!previous;

  // Fetch template options on component mount
  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await axiosInstance.get(
          "/documents/letter-templates/options/"
        );
        setTemplateOptions(response.data.templates || []);
      } catch (err) {
        const msg = "خطا در بارگذاری قالب‌ها";
        setError(msg);
        setToast({ message: msg, type: "error" });
        console.error("Template fetch error:", err);
      }
    };
    fetchTemplates();
  }, []);

  // Fetch letters with pagination
  const fetchLetters = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        page: currentPage,
        page_size: pageSize,
      };
      const response = await axiosInstance.get("/documents/letters/", { params });
      const data = response.data;
      setLetters(data.results || []);
      setCount(data.count || 0);
      setNext(data.next);
      setPrevious(data.previous);
      setTotalPages(data.count ? Math.ceil(data.count / pageSize) : 1);
    } catch (err) {
      const msg = "خطا در بارگذاری نامه‌ها";
      setError(msg);
      setToast({ message: msg, type: "error" });
      console.error("Letters fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, [currentPage, pageSize]);

  useEffect(() => {
    fetchLetters();
  }, [fetchLetters]);

  const handleDownload = async (letterId, title) => {
    try {
      const format = selectedFormat || "pdf";
      const templateId = selectedTemplate || "1";
      const endpoint =
        format === "pdf"
          ? "/documents/letter/render-pdf/"
          : "/documents/letter/render-docx/";

      const response = await axiosInstance.post(
        endpoint,
        {
          letter_id: letterId,
          template_id: templateId,
        },
        {
          responseType: "blob",
        }
      );

      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${title}.${format}`;
      link.click();
      URL.revokeObjectURL(url);
      setToast({ message: "دانلود با موفقیت انجام شد.", type: "success" });
    } catch (err) {
      const msg = "خطا در دانلود نامه";
      setError(msg);
      setToast({ message: msg, type: "error" });
      console.error("Download error:", err);
    }
  };

  const handleDelete = async (letterId) => {
    if (!window.confirm("آیا از حذف این نامه اطمینان دارید؟")) return;

    try {
      await axiosInstance.delete(`/documents/letters/${letterId}/`);
      setLetters((prev) => prev.filter((letter) => letter.id !== letterId));
      setToast({ message: "نامه با موفقیت حذف شد.", type: "success" });
    } catch (err) {
      const msg = "خطا در حذف نامه";
      setError(msg);
      setToast({ message: msg, type: "error" });
      console.error("Delete error:", err);
    }
  };

  const handlePageChange = (e) => setCurrentPage(Number(e.target.value));
  const handleNextPage = () => hasNext && setCurrentPage((p) => p + 1);
  const handlePreviousPage = () => hasPrevious && setCurrentPage((p) => p - 1);
  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="mt-24 pb-10 bg-gray-50 min-h-screen font-vazir" dir="rtl">
      <HotToastMessage
        message={toast.message}
        type={toast.type}
        duration={3000}
        onClose={() => setToast({ message: "", type: "info" })}
        position="top"
      />

      <div className="mx-auto p-6 bg-white/70 backdrop-blur-md rounded-xl shadow-lg border border-white/20">
        <h2 className="text-2xl font-semibold text-gray-800 text-right mb-6">
          لیست نامه‌های ایجاد شده
        </h2>

        {/* Format & Template Select */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 text-right mb-2">
              فرمت فایل:
            </label>
            <select
              value={selectedFormat}
              onChange={(e) => setSelectedFormat(e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-lg bg-white/90 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 text-right"
            >
              <option value="pdf">PDF</option>
              <option value="docx">DOCX</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 text-right mb-2">
              قالب نامه:
            </label>
            <select
              value={selectedTemplate}
              onChange={(e) => setSelectedTemplate(e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-lg bg-white/90 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 text-right"
            >
              <option value="1">قالب پیش‌فرض</option>
              {templateOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Loading / Error */}
        {loading && <p className="text-blue-500 animate-pulse text-center">در حال بارگذاری...</p>}
        {error && <p className="text-red-500 text-center">{error}</p>}

        {/* Table & Pagination */}
        {!loading && !error && (
          <>
            {letters.length === 0 ? (
              <p className="text-gray-600 text-center">هیچ نامه‌ای یافت نشد.</p>
            ) : (
              <>
                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pageSize={pageSize}
                  pageSizeOptions={[10, 20, 50, 100]}
                  hasNext={hasNext}
                  hasPrevious={hasPrevious}
                  onPageChange={handlePageChange}
                  onNextPage={handleNextPage}
                  onPreviousPage={handlePreviousPage}
                  onPageSizeChange={handlePageSizeChange}
                />

                <div className="overflow-x-auto">
                  <table className="w-full bg-white/80 backdrop-blur-md rounded-lg shadow-lg">
                    <thead>
                      <tr className="bg-blue-50/50">
                        <th className="p-4 text-right font-semibold text-gray-800">عنوان نامه</th>
                        <th className="p-4 text-right font-semibold text-gray-800">تاریخ</th>
                        <th className="p-4 text-right font-semibold text-gray-800">عملیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {letters.map((letter) => (
                        <tr key={letter.id} className="border-t border-gray-200 hover:bg-gray-50/50">
                          <td className="p-4 text-right font-medium text-gray-800">
                            {letter.title}
                          </td>
                          <td className="p-4 text-right text-gray-600">
                            {letter.date}
                          </td>
                          <td className="p-4 text-right">
                            <div className="flex justify-end gap-2">
                              <button
                                onClick={() => handleDownload(letter.id, letter.title)}
                                className="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 transition-colors flex items-center text-sm"
                              >
                                دانلود
                              </button>
                              <Link
                                to={`/letter/edit/${letter.id}`}
                                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center text-sm"
                              >
                                <Edit className="w-4 h-4 ml-1" />
                                ویرایش
                              </Link>
                              <button
                                onClick={() => handleDelete(letter.id)}
                                className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors flex items-center text-sm"
                              >
                                <Trash2 className="w-4 h-4 ml-1" />
                                حذف
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pageSize={pageSize}
                  pageSizeOptions={[10, 20, 50, 100]}
                  hasNext={hasNext}
                  hasPrevious={hasPrevious}
                  onPageChange={handlePageChange}
                  onNextPage={handleNextPage}
                  onPreviousPage={handlePreviousPage}
                  onPageSizeChange={handlePageSizeChange}
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LetterList;
